<div class="group-qr">
  <p>{{_(KEYS.CRUD.INIT_DEVICE_HELP_TEXT)}}</p>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">{{_(KEYS.CRUD.INIT_DEVICE)}}</h5>
      <app-init-device-qr-code></app-init-device-qr-code>

      <br>
      <span class="txt-code">{{qrData}}</span>
    </div>
  </div>

  <br>
  <p>{{_(KEYS.CRUD.INSTALL_APP_HELP_TEXT)}}</p>

  <ng-container *ngIf="iosAppLink">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">iOS app (store)</h5>
        <div class="qr-wrap">
          <i class="fa fa-apple qr-inner"></i>
          <qrcode [qrdata]="iosAppLink" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
        </div>

        <br>
        <a class="btn btn-sm btn-primary" [href]="iosAppLink" target="_blank">Download</a>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="androidAppStoreLink">
    <br><br>
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Android app (store)</h5>
        <div class="qr-wrap">
          <i class="fa fa-android qr-inner"></i>
          <qrcode [qrdata]="androidAppStoreLink" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
        </div>

        <br>
        <a class="btn btn-sm btn-primary" [href]="androidAppStoreLink" target="_blank">Download</a>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="androidAppLink">
    <br><br>
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Android app (download)</h5>
        <div class="qr-wrap">
          <i class="fa fa-android qr-inner"></i>
          <qrcode [qrdata]="androidAppLink" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
        </div>

        <br>
        <a class="btn btn-sm btn-primary" [href]="androidAppLink" target="_blank">Download</a>
      </div>
    </div>
  </ng-container>
</div>


